import { IStoreItem, IWasmStoreGeometry, IWasmStoreMarker } from "~/wasm/store/interfaces";
import { watch } from "../util";
import { IMapContentState } from "./interfaces";
import type { store as Store } from "~/state/store";

interface IMapContentChange {
	store: typeof Store;
	onMarkersChange: (ids: Array<IStoreItem["id"]>, markers: Array<IWasmStoreMarker>) => void;
	onGeometriesChange: (ids: Array<IStoreItem["id"]>, geometries: Array<IWasmStoreGeometry>) => void;
}

// radeji cislo, nez serializace a testy celych poli
function getChange(first: IMapContentState, second: IMapContentState): boolean {
	return first.changeId === second.changeId;
}

export function watchMapContentChanges({
	store,
	onMarkersChange = () => {},
	onGeometriesChange = () => {},
}: IMapContentChange) {
	const watchMapContent = watch(store.getState, "mapContent", getChange);
	const unsub = store.subscribe(watchMapContent(newData => {
		switch (newData.affectedType) {
			case "marker":
				onMarkersChange(newData.affectedMarkerIds, newData.markers);
				break;

			case "geometry":
				onGeometriesChange(newData.affectedGeometryIds, newData.geometries);
				break;

			case "both":
				onMarkersChange(newData.affectedMarkerIds, newData.markers);
				onGeometriesChange(newData.affectedGeometryIds, newData.geometries);
				break;

			default:
		}
	}));

	return unsub;
}
